<form role="form" #form="ngForm">
  <div class="form-group">
    <label (click)="printDebugInfo()">{{ 'BANK_ACCOUNT_COUNTRY' | translate }}</label>

    <div class="form-group">
      <select id="countryPicker" name="countryPicker" class="form-select" [(ngModel)]="country">
        @for (option of supportedCountries; track option) {
          <option [value]="option.countryCode">
            {{ option.name | translate }}
          </option>
        }
      </select>
    </div>

    <label (click)="printDebugInfo()">{{ 'BANK_ACCOUNT_CURRENCY' | translate }}</label>
    <div class="form-group">
      <select id="currencyPicker" name="currencyPicker" class="form-select" [(ngModel)]="currency">
        @for (option of supportedCurrencies; track option) {
          <option [value]="option">
            {{ option | uppercase }}
          </option>
        }
      </select>
    </div>

    <label (click)="printDebugInfo()">{{ 'BANK_ACCOUNT_DETAILS' | translate }}</label>

    @if (bankCodeLabel) {
      <div class="form-group">
        <input
          id="bankCode"
          name="bankCode"
          #bankCodeControl="ngModel"
          type="text"
          class="form-control"
          [class.missing]="isMissing(bankCodeControl)"
          [class.complete]="isComplete(bankCodeControl)"
          [class.invalid]="isInvalid(bankCodeControl)"
          [(ngModel)]="bankCode"
          [placeholder]="bankCodeLabel | translate"
          required
          />
      </div>
    }

    @if (branchCodeLabel) {
      <div class="form-group">
        <input
          id="branchCode"
          name="branchCode"
          #branchCodeControl="ngModel"
          type="text"
          class="form-control"
          [class.missing]="isMissing(branchCodeControl)"
          [class.complete]="isComplete(branchCodeControl)"
          [class.invalid]="isInvalid(branchCodeControl)"
          [(ngModel)]="branchCode"
          [placeholder]="branchCodeLabel | translate"
          required
          />
      </div>
    }

    @if (routingNumberLabel) {
      <div class="form-group">
        <input
          id="routingNumber"
          name="routingNumber"
          #routingNumberControl="ngModel"
          type="text"
          class="form-control"
          [class.missing]="isMissing(routingNumberControl)"
          [class.complete]="isComplete(routingNumberControl)"
          [class.invalid]="isInvalid(routingNumberControl)"
          [(ngModel)]="routingNumber"
          [placeholder]="routingNumberLabel | translate"
          required
          />
      </div>
    }

    @if (isInvalidRoutingNumber && !isRoutingNumberPristine) {
      <div class="alert alert-danger">
        {{ invalidRoutingNumberError | translate }}
      </div>
    }

    <div class="form-group">
      <input
        id="accountNumber"
        name="accountNumber"
        #accountNumberControl="ngModel"
        type="text"
        class="form-control"
        [class.missing]="isMissing(accountNumberControl)"
        [class.complete]="isComplete(accountNumberControl)"
        [class.invalid]="isInvalid(accountNumberControl)"
        [(ngModel)]="accountNumber"
        [placeholder]="accountNumberLabel | translate"
        required
        />
    </div>

    @if (isInvalidAccountNumber && !isAccountNumberPristine) {
      <div class="alert alert-danger">
        {{ 'INVALID_BANK_ACCOUNT_NUMBER' | translate }}
      </div>
    }
  </div>
</form>
